"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Radio = _interopRequireDefault(require("./Radio"));

exports.default = _Radio.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/Radio/index.js
// module id = 314
// module chunks = 0